import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './RsLoaderCircular.scss';

function RsLoaderCircular({ className, position }) {
  return (
    <div className={cn('rs-loader-circular', className)}>
      <div className="rs-loader-circular__circle" />
      <div className="rs-loader-circular__circle" />
      <div className="rs-loader-circular__circle" />
      <div className={cn('rs-loader-circular__position', { 'two-digits': position && position.length && position.length > 1 })}>
        {position}
      </div>
    </div>
  );
}

RsLoaderCircular.propTypes = {
  className: PropTypes.string,
  position: PropTypes.string,
};

export default RsLoaderCircular;
